import type { WarehouseMiscellaneousFeeFormValues } from "./schemas"
import { WarehouseStatus } from "./types"

import { WarehouseType } from "@/graphql/codegen/graphql"
import { createStatusMap } from "@/utils/statusMap"

export const WAREHOUSE_TYPE_TO_LABEL: ReadonlyMap<string, string> = new Map([
  [WarehouseType.AkrochemManaged, "Akrochem Managed"],
  [WarehouseType.AkrochemUnmanaged, "Akrochem Unmanaged"],
  [WarehouseType.Consignment, "Consignment"],
])

export const WAREHOUSE_STATUS_MAP = createStatusMap<
  WarehouseStatus,
  "primary" | "secondary" | "default" | "error" | "info" | "success" | "warning"
>([
  [WarehouseStatus.Active, "success"],
  [WarehouseStatus.Inactive, "secondary"],
])

export const BLANK_WAREHOUSE_MISCELLANEOUS_FEE: WarehouseMiscellaneousFeeFormValues = {
  type: "",
  amount: "",
}
